import { Skeleton, StanDataRowGroup } from '@/components';
import { BROADCAST_HEADER_COLUMNS, getGridTemplate } from '../../broadcasts/constants/gridColumns';

/**
 * Skeleton loading state that mimics the appearance of broadcast rows
 */
export const BroadcastsTabSkeleton = () => {
    const gridTemplate = getGridTemplate();

    return (
        <StanDataRowGroup headerColumns={BROADCAST_HEADER_COLUMNS} maxActionButtonCount={1}>
            <div className='space-y-4 md:space-y-6'>
                {Array.from({ length: 5 }).map((_, index) => (
                    <div
                        key={index}
                        className='bg-bg-canvas shadow-stan grid h-20 grid-cols-[1fr_auto] items-center gap-4 rounded-lg px-4 md:px-6'
                    >
                        {/* Mobile: Single column layout */}
                        <div className='flex w-full flex-col gap-2 md:hidden'>
                            <div className='flex items-center gap-2'>
                                <Skeleton className='size-5 flex-shrink-0 rounded-md' />
                                <Skeleton className='h-4 w-40' />
                            </div>
                            <div className='flex items-center gap-4'>
                                <Skeleton className='h-3 w-16' />
                                <Skeleton className='h-5 w-20 rounded-full' />
                            </div>
                        </div>

                        {/* Desktop: Grid layout matching actual broadcast row */}
                        <div
                            className='hidden w-full items-center md:grid'
                            style={{ gridTemplateColumns: gridTemplate }}
                        >
                            {/* Name column - 36% */}
                            <div className='flex items-center gap-2 pr-4'>
                                <Skeleton className='size-5 flex-shrink-0 rounded-md' />
                                <Skeleton className='h-4 w-40' />
                            </div>
                            {/* Sent column - 12% */}
                            <Skeleton className='h-4 w-10' />
                            {/* Opens column - 12% */}
                            <Skeleton className='h-4 w-12' />
                            {/* Clicks column - 12% */}
                            <Skeleton className='h-4 w-12' />
                            {/* Status column - 28% */}
                            <Skeleton className='h-6 w-16 rounded-full' />
                        </div>

                        {/* Action button placeholder */}
                        <div className='flex flex-shrink-0 items-center justify-end'>
                            <Skeleton className='size-8 rounded-md' />
                        </div>
                    </div>
                ))}
            </div>
        </StanDataRowGroup>
    );
};
